import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Globe, Twitter, Linkedin, X, AlertCircle, Mail, Phone, MapPin, ExternalLink, Info, CheckCircle, XCircle } from 'lucide-react';
import SecurityModal from './Footer/securityTerm'; 
import TermsOfServiceModal from './Footer/TermsOfService'; 
import  PrivacyPolicyModal from './Footer/PrivacyPolicy'; 
import AboutUsModal from './Footer/aboutUs';
import ContactModal from './Footer/ContactUs';
import FaqModal from './Footer/FAQ';
import HelpCenterModal from './Footer/HelpCenter';

// Footer Component with Popups
const Footer = () => {
  // State for different modals
  const [contactModalOpen, setContactModalOpen] = useState(false);
  const [statusModalOpen, setStatusModalOpen] = useState(false);
  const [aboutModalOpen, setAboutModalOpen] = useState(false);

  const [privacyPolicyModalOpen, setPrivacyPolicyModalOpen] = useState(false);
  const [termsOfServiceModalOpen, setTermsOfServiceModalOpen] = useState(false);
  const [securityModalOpen, setSecurityModalOpen] = useState(false);
  const [faqModalOpen, setFaqModalOpen] = useState(false);
  const [helpCenterModalOpen, setHelpCenterModalOpen] = useState(false);
   
  
  // Current year for copyright
  const currentYear = new Date().getFullYear();

  // Sample system status data
  const systemStatus = [
    { name: "API Services", status: "operational", uptime: "99.99%" },
    { name: "Dashboard", status: "operational", uptime: "99.95%" },
    { name: "Authentication", status: "operational", uptime: "99.98%" },
    { name: "Threat Database", status: "degraded", uptime: "98.72%" },
    { name: "Monitoring Tools", status: "operational", uptime: "99.91%" }
  ];


  return (
    <>
      <footer className="bg-gray-100 dark:bg-gray-800 py-12">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div>
              <h3 className="text-xl font-bold mb-4 dark:text-white">0x10LayerFF</h3>
              <p className="text-gray-600 dark:text-gray-400 mb-4">
                Comprehensive cybersecurity solutions for modern enterprises.
              </p>
              <button 
                onClick={() => setAboutModalOpen(true)}
                className="text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300 text-sm font-medium flex items-center gap-1"
              >
                <span>About Us</span>
                <Info size={14} />
              </button>
            </div>
            
            <div>
              <h4 className="font-semibold mb-4 dark:text-white">Quick Links</h4>
              <ul className="space-y-2">
                <li><Link to="#dashboard" className="text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors">Dashboard</Link></li>
                <li><Link to="#tools" className="text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors">Security Tools</Link></li>
                <li><Link to="#reports" className="text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors">Threat Reports</Link></li>
                <li><Link to="#pricing" className="text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors">Pricing</Link></li>
              </ul>
            </div>
            
            <div> 
              <h4 className="font-semibold mb-4 dark:text-white">Support</h4>
              <ul className="space-y-2">
                <li>
                    <button 
                    onClick={() => setHelpCenterModalOpen(true)}
                    className="text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors text-left w-auto bg-transparent"
                  >
                    Help Center
                  </button>                    
                    </li>
                <li>
                  <button 
                    onClick={() => setContactModalOpen(true)}
                    className="text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors text-left w-auto bg-transparent"
                  >
                    Contact Us
                  </button>
                </li>
                <li>
                  <button 
                    onClick={() => setStatusModalOpen(true)}
                    className="text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors text-left w-auto bg-transparent"
                  >
                    System Status
                  </button>
                </li>
                <li>
                    <button 
                        onClick={() => setFaqModalOpen(true)}
                        className="text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors text-left w-auto bg-transparent"
                    >
                        FAQs
                    </button>
                </li>
              </ul>
            </div>
            
            <div>
              <h4 className="font-semibold mb-4 dark:text-white">Follow Us</h4>
              <div className="flex space-x-4 mb-6">
               
                <a 
                  href="https://x.com/0X10LayerFF?t=aJ36mJOzE2ymNUd9LBpokg&s=08" 
                  className="text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors" 
                  aria-label="Twitter"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                  </svg>
                </a>
                <a 
                  href="https://www.instagram.com/0x10.layerff?igsh=dXU4NmJyMjFtdzI4&utm_source=qr" 
                  className="text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors" 
                  aria-label="Instagram"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
                    <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
                    <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
                  </svg>
                </a>
                <a 
                  href="https://linkedin.com/company/0x10layerff" 
                  className="text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors" 
                  aria-label="LinkedIn"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                  </svg>
                </a>
              </div>
              
              <div className="bg-white dark:bg-gray-700 p-4 rounded-lg shadow-sm">
                <h5 className="font-medium text-sm mb-2 dark:text-white">Subscribe to our newsletter</h5>
                <div className="flex">
                  <input 
                    type="email" 
                    placeholder="Your email" 
                    className="flex-grow px-3 py-2 border border-gray-300 dark:border-gray-600 dark:bg-gray-800 dark:text-white rounded-l-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
                  />
                  <button className="bg-blue-600 hover:bg-blue-700 text-white px-3 py-2 rounded-r-md transition-colors text-sm">
                    Subscribe
                  </button>
                </div>
              </div>
            </div>
          </div>
          
          <div className="border-t border-gray-200 dark:border-gray-700 mt-8 pt-6">
            <div className="flex flex-col md:flex-row justify-between items-center">
              <p className="text-gray-600 dark:text-gray-400 text-sm">
                © {currentYear} 0x10LayerFF. All Rights Reserved.
              </p>
              
              <div className="flex space-x-6 mt-4 md:mt-0">
                <button 
                    onClick={() => setPrivacyPolicyModalOpen(true)} 
                    className="text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 text-sm"
                >
                    Privacy Policy
                </button>
                <button 
                    onClick={() => setTermsOfServiceModalOpen(true)} 
                    className="text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 text-sm"
                >
                    Terms of Service
                </button>
                <button 
                    onClick={() => setSecurityModalOpen(true)} 
                    className="text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 text-sm"
                >
                    Security
                </button>
                
                {/* Modals */}
                <PrivacyPolicyModal 
                    privacyPolicyModalOpen={privacyPolicyModalOpen} 
                    setPrivacyPolicyModalOpen={setPrivacyPolicyModalOpen} 
                />
                <TermsOfServiceModal 
                    termsOfServiceModalOpen={termsOfServiceModalOpen} 
                    setTermsOfServiceModalOpen={setTermsOfServiceModalOpen} 
                />
                <SecurityModal 
                    securityModalOpen={securityModalOpen} 
                    setSecurityModalOpen={setSecurityModalOpen} 
                />
                </div>
                <AboutUsModal 
                    aboutModalOpen={aboutModalOpen} 
                    setAboutModalOpen={setAboutModalOpen} 
                />  
                <ContactModal 
                    contactModalOpen={contactModalOpen} 
                    setContactModalOpen={setContactModalOpen} 
                />       
                <FaqModal 
                    faqModalOpen={faqModalOpen} 
                    setFaqModalOpen={setFaqModalOpen} 
                    setContactModalOpen={setContactModalOpen}
                />     
                 <HelpCenterModal 
                    helpCenterModalOpen={helpCenterModalOpen} 
                    setHelpCenterModalOpen={setHelpCenterModalOpen} 
                    setContactModalOpen={setContactModalOpen}
                />                  
            </div>
            
            <p className="text-gray-600 dark:text-gray-400 text-center mt-4 text-sm">
              Developed by <a href="https://www.0x10layer.com" className="text-blue-600 hover:underline">F/N Nuru The_geek</a>
            </p>
          </div>
        </div>
      </footer>

      {/* System Status Modal */}
      {statusModalOpen && (
        <div className="fixed inset-0 bg-black/70 z-50 flex items-center justify-center p-4 backdrop-blur-sm" onClick={() => setStatusModalOpen(false)}>
          <div className="bg-white dark:bg-gray-800 rounded-xl max-w-2xl w-full p-6 shadow-2xl" onClick={e => e.stopPropagation()}>
            <div className="flex justify-between items-center mb-6">
              <h3 className="text-xl font-bold dark:text-white">System Status</h3>
              <button 
                onClick={() => setStatusModalOpen(false)}
                className="text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200"
              >
                <X size={20} />
              </button>
            </div>
            
            <div className="mb-6">
              <div className="flex items-center">
                <div className={`w-3 h-3 rounded-full mr-2 ${
                  systemStatus.every(s => s.status === 'operational') 
                    ? 'bg-green-500' 
                    : systemStatus.some(s => s.status === 'down') 
                      ? 'bg-red-500' 
                      : 'bg-yellow-500'
                }`}></div>
                <h4 className="font-medium dark:text-white">
                  {systemStatus.every(s => s.status === 'operational') 
                    ? 'All Systems Operational' 
                    : systemStatus.some(s => s.status === 'down') 
                      ? 'Major Outage Detected' 
                      : 'Partial System Degradation'}
                </h4>
              </div>
              <p className="text-gray-600 dark:text-gray-400 text-sm mt-2">
                Last updated: {new Date().toLocaleString()}
              </p>
            </div>
            
            <div className="overflow-hidden rounded-lg border border-gray-200 dark:border-gray-700">
              <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
                <thead className="bg-gray-50 dark:bg-gray-700">
                  <tr>
                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">Service</th>
                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">Status</th>
                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">Uptime</th>
                  </tr>
                </thead>
                <tbody className="bg-white dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-700">
                  {systemStatus.map((service, index) => (
                    <tr key={index} className={index % 2 === 0 ? 'bg-white dark:bg-gray-800' : 'bg-gray-50 dark:bg-gray-700/50'}>
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900 dark:text-white">{service.name}</td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm">
                        <div className="flex items-center">
                          {service.status === 'operational' ? (
                            <CheckCircle size={16} className="text-green-500 mr-2" />
                          ) : service.status === 'down' ? (
                            <XCircle size={16} className="text-red-500 mr-2" />
                          ) : (
                            <AlertCircle size={16} className="text-yellow-500 mr-2" />
                          )}
                          <span className={`
                            ${service.status === 'operational' ? 'text-green-500' : ''}
                            ${service.status === 'degraded' ? 'text-yellow-500' : ''}
                            ${service.status === 'down' ? 'text-red-500' : ''}
                          `}>
                            {service.status.charAt(0).toUpperCase() + service.status.slice(1)}
                          </span>
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400">{service.uptime}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            
            <div className="mt-6 flex justify-between">
              <a href="/status-history" className="text-blue-600 dark:text-blue-400 text-sm flex items-center">
                <span>View Historical Uptime</span>
                <ExternalLink size={14} className="ml-1" />
              </a>
              <button 
                onClick={() => setStatusModalOpen(false)}
                className="px-4 py-2 bg-gray-100 hover:bg-gray-200 dark:bg-gray-700 dark:hover:bg-gray-600 text-gray-800 dark:text-gray-200 rounded-md transition-colors text-sm"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

         

      
    </>
  );
};

export default Footer;